// Functions used for prerendering aim - checks if we could use window object.
// In case of prerendering we use Node environment where window object doesn't exist

export const isBrowserEnv = () => typeof window !== "undefined";

export const isNodeEnv = () => typeof window === "undefined";
